export enum PolicyResourceTypes {
  Corporate = 'Corporate',
  PartnerAccount = 'PartnerAccount',
  Account = 'Account'
}
